// @flow
import React from 'react'
import {
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  TextField
} from '@material-ui/core'
import i18n from 'i18next'
import styles from './styles'

type Props = {
  company: Object,
  invoiceEmail: Object,
  invoiceFirstSurname: Object,
  invoiceName: Object,
  invoicePersonType: Object,
  invoiceSecondSurname: Object,
  nif: Object,
  onInputChange: Function,
  onInvoicePersonTypeChange: Function,
  wantsInvoiceLegal: boolean,
  wantsInvoiceNatural: boolean
}

export const AddAddressInvoiceForm = (props: Props) => (
  <>
    <FormControl
      error={props.invoicePersonType.error}
      fullWidth
      margin='none'
      required={props.invoicePersonType.isRequired}
      variant='outlined'
    >
      <InputLabel htmlFor='delivery-personType'>
        {i18n.t('checkout.label.personType')}
      </InputLabel>
      <Select
        input={
          <OutlinedInput
            labelWidth={168}
            name='invoicePersonType'
            id='delivery-personType'
          />
        }
        onChange={props.onInvoicePersonTypeChange}
        value={props.invoicePersonType.value}
      >
        <MenuItem value={'natural'}>
          {i18n.t('checkout.label.personTypeNatural')}
        </MenuItem>
        <MenuItem value={'legal'}>
          {i18n.t('checkout.label.personTypeLegal')}
        </MenuItem>
      </Select>

      {props.invoicePersonType.error && (
        <FormHelperText error>
          {i18n.t('checkout.error.personType')}
        </FormHelperText>
      )}
    </FormControl>

    {props.wantsInvoiceNatural && (
      <Grid item xs={12} style={styles.container}>
        <Grid container spacing={16}>
          <Grid item xs={12} sm={6}>
            <TextField
              error={props.invoiceName.error}
              helperText={
                props.invoiceName.error && i18n.t('checkout.error.invoiceName')
              }
              id='delivery-invoiceName'
              label={i18n.t('checkout.label.invoiceName')}
              name='invoiceName'
              value={props.invoiceName.value}
              onChange={props.onInputChange}
              margin='none'
              variant='outlined'
              required={props.invoiceName.isRequired}
              type='text'
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              error={props.invoiceFirstSurname.error}
              helperText={
                props.invoiceFirstSurname.error &&
                i18n.t('checkout.error.invoiceFirstSurname')
              }
              id='delivery-invoiceFirstSurname'
              label={i18n.t('checkout.label.invoiceFirstSurname')}
              name='invoiceFirstSurname'
              value={props.invoiceFirstSurname.value}
              onChange={props.onInputChange}
              margin='none'
              variant='outlined'
              required={props.invoiceFirstSurname.isRequired}
              type='text'
              fullWidth
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              id='delivery-invoiceSecondSurname'
              label={i18n.t('checkout.label.invoiceSecondSurname')}
              margin='none'
              name='invoiceSecondSurname'
              onChange={props.onInputChange}
              required={props.invoiceSecondSurname.isRequired}
              type='text'
              value={props.invoiceSecondSurname.value}
              variant='outlined'
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              error={props.invoiceEmail.error}
              helperText={
                props.invoiceEmail.error &&
                i18n.t('checkout.error.invoiceEmail')
              }
              id='delivery-invoiceEmail'
              label={i18n.t('checkout.label.invoiceEmail')}
              name='invoiceEmail'
              value={props.invoiceEmail.value}
              onChange={props.onInputChange}
              margin='none'
              variant='outlined'
              required={props.invoiceEmail.isRequired}
              type='text'
              fullWidth
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              error={props.nif.error}
              helperText={
                props.nif.error && i18n.t('checkout.error.invoiceNIF')
              }
              id='delivery-nif'
              label={i18n.t('checkout.label.invoiceNIF')}
              name='nif'
              value={props.nif.value}
              onChange={props.onInputChange}
              margin='none'
              variant='outlined'
              required={props.nif.isRequired}
              type='text'
              fullWidth
            />
          </Grid>
        </Grid>
      </Grid>
    )}

    {props.wantsInvoiceLegal && (
      <Grid item xs={12} style={styles.container}>
        <Grid container spacing={16}>
          <Grid item xs={12} sm={6}>
            <TextField
              error={props.company.error}
              helperText={
                props.company.error && i18n.t('checkout.error.invoiceCompany')
              }
              id='delivery-invoiceName'
              label={i18n.t('checkout.label.invoiceCompany')}
              name='company'
              value={props.company.value}
              onChange={props.onInputChange}
              margin='none'
              variant='outlined'
              required={props.company.isRequired}
              type='text'
              fullWidth
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              error={props.invoiceEmail.error}
              helperText={
                props.invoiceEmail.error &&
                i18n.t('checkout.error.invoiceEmail')
              }
              id='delivery-invoiceEmail'
              label={i18n.t('checkout.label.invoiceEmail')}
              name='invoiceEmail'
              value={props.invoiceEmail.value}
              onChange={props.onInputChange}
              margin='none'
              variant='outlined'
              required={props.invoiceEmail.isRequired}
              type='text'
              fullWidth
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              error={props.nif.error}
              helperText={
                props.nif.error && i18n.t('checkout.error.invoiceCIF')
              }
              id='delivery-nif'
              label={i18n.t('checkout.label.invoiceCIF')}
              name='nif'
              value={props.nif.value}
              onChange={props.onInputChange}
              margin='none'
              variant='outlined'
              required={props.nif.isRequired}
              type='text'
              fullWidth
            />
          </Grid>
        </Grid>
      </Grid>
    )}
  </>
)

export default AddAddressInvoiceForm
